<span class="badge badge-pill {{ online ? 'badge-success' : 'badge-danger' }}">
  {{ online ? 'Online' : 'Offline' }}
</span>
